import {Pipe, PipeTransform} from "@angular/core";

@Pipe({name: 'abs', standalone: false})
export class AbsolutePipe implements PipeTransform {
  transform(value: number | null): number | null {
    return value != null ? Math.abs(value) : null;
  }
}
